// frontend/src/components/common/CompareButton.js
import React from 'react';
import { FaExchangeAlt, FaCheck } from 'react-icons/fa';
import { useCompare } from '../../context/CompareContext';

function CompareButton({ vehicle, className = "" }) {
  const { addToCompare, removeFromCompare, isInCompare } = useCompare();
  const isSelected = isInCompare(vehicle.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isSelected) {
      removeFromCompare(vehicle.id);
    } else {
      addToCompare(vehicle);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`p-2 rounded-full transition-all duration-200 shadow-sm flex items-center justify-center gap-1 ${
        isSelected 
          ? 'bg-blue-600 text-white hover:bg-blue-700' 
          : 'bg-white text-gray-500 hover:text-blue-600 hover:bg-blue-50'
      } ${className}`}
      title={isSelected ? "Remove from Compare" : "Add to Compare"}
    >
      {isSelected ? <FaCheck size={14} /> : <FaExchangeAlt size={14} />}
      {isSelected && <span className="text-xs font-bold ml-1 hidden sm:inline">Added</span>}
    </button>
  );
}

export default CompareButton;